import * as yup from 'yup';

export const schema = yup.object().shape({
  des_grupo_empresa: yup.string().required(),
});
